import { createColumnHelper } from "@tanstack/react-table";
import { IconButton, Tooltip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const columnHelper = createColumnHelper();

const IRelUsuarioMarcaOperacion = ({ handleDelete } : any) => {
    return [
        columnHelper.accessor("nombreArchivo", {
            header: () => "Archivo",
            cell: (info) => info.getValue(),
        }),
        columnHelper.accessor("marcaTipoOperacion", {
            header: () => "Marca - Tipo Operación",
            cell: (info) => info.getValue(),
        }),
        columnHelper.accessor("accions", {
            header: () => "",
            cell: ({row}) => (
                <Tooltip onClick={() => handleDelete(row.original)} title="Eliminar">
                    <IconButton>
                        <CloseIcon />
                    </IconButton>
                </Tooltip>
            )
        }),
    ];
};

export default IRelUsuarioMarcaOperacion;
